import headerModel, { HeaderNavItem } from "../../models/text-models/header.models";
import { renderIcon } from "../icons/icon-render";
import { Menu, MenuItem, Menulink, Wrapper } from "./header.style";

const renderItem = (item: HeaderNavItem) => {
  return (
    <MenuItem>
      <Menulink href={item.href}>{item.label}</Menulink>
      {renderIcon(item.icon, { color: '#fff' })}
    </MenuItem>
  )
}

const Header = () => {
  return (
    <Wrapper>
      <Menu>
        {headerModel.nav.map((item) => renderItem(item))}
      </Menu>
    </Wrapper>
  )
};

export default Header;